import React from 'react';
import {Link} from 'react-router-dom';

import {CheckBox} from '@pb/kit-component-checkbox';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Loading from '@pb/kit-component-loading';
import {Cell, Row} from '@pb/kit-component-table';

import {descriptionW, numberW, rulesW, selectW, usersW, vendorW} from '../constants';

import type {VendorTableRow} from '../hooks/useVendorTableData';

type Props = {
    vendor: VendorTableRow,
    index: number,
    pageSize: number,
    currentPage: number,
    selected: boolean,
    onToggle: (checked: boolean, shiftKey: boolean) => void,
};

export const VendorManagementTableRow: React.FC<Props> = ({
    vendor,
    index,
    pageSize,
    currentPage,
    selected,
    onToggle,
}) => {
    const assignedUsers = vendor.assignedUsers ?? 0;
    const ruleCount = vendor.rules?.length ?? 0;
    const isUsersLoading = vendor.isUsersLoading;
    const isRulesLoading = vendor.isRulesLoading;

    return (
        <Row key={vendor.id}>
            <Cell width={numberW}>{(currentPage - 1) * pageSize + index + 1}</Cell>
            <Cell className="text-align_center" width={selectW}>
                <CheckBox
                    checked={selected}
                    onCheckBoxChange={({event}: {event: React.ChangeEvent<HTMLInputElement>}) => {
                        const native = event.nativeEvent as MouseEvent | KeyboardEvent;
                        const shiftKey = Boolean(native?.shiftKey);
                        onToggle(event.target.checked, shiftKey);
                    }}
                    usePropsOnly={true}
                />
            </Cell>
            <Cell width={vendorW}>
                <Link to={`/vendors/${vendor.id}`} style={{display: 'block', maxWidth: '100%', textAlign: 'left'}}>
                    <EllipsisTextHint title={vendor.vendorName}>
                        {vendor.vendorName}
                    </EllipsisTextHint>
                </Link>
            </Cell>
            <Cell width={descriptionW}>
                {vendor.description ? (
                    <EllipsisTextHint title={vendor.description}>
                        {vendor.description}
                    </EllipsisTextHint>
                ) : null}
            </Cell>
            <Cell width={rulesW}>
                {isRulesLoading ? (
                    <Loading type="ICON"/>
                ) : (
                    <>
                        {ruleCount > 0 ? (
                            <EllipsisTextHint title={`${ruleCount}`}>
                                {ruleCount}
                            </EllipsisTextHint>
                        ) : null}
                    </>
                )}
            </Cell>
            <Cell width={usersW}>
                {isUsersLoading ? (
                    <Loading type="ICON"/>
                ) : (
                    <>
                        {assignedUsers > 0 ? (
                            <EllipsisTextHint title={`${assignedUsers}`}>
                                {assignedUsers}
                            </EllipsisTextHint>
                        ) : null}
                    </>
                )}
            </Cell>

        </Row>
    );
};
